export const BASE_URL = 'https://backend.carepay.money'
export const LUMI_API_BASE =
  process.env.REACT_APP_LUMI_API_URL || 'https://lumi-backend.carepay.money'

export const LOAN_APIS = {
    // QR Code
    GET_QR_CODE: (doctorId) =>
        `${BASE_URL}/getQrCode?doctorId=${doctorId}`,

    // Activities and Timeline
    GET_ACTIVITIES_LOG: (userId) =>
        `${BASE_URL}/activitiesLog?userId=${userId}`,
    
    GET_USER_LOAN_STATUS: (loanId) =>
        `${BASE_URL}/status/getUserLoanStatus?loanId=${loanId}`,

    // Product and EMI Plans
    GET_ASSIGNED_PRODUCT: (userId) =>
        `${BASE_URL}/userDetails/getAssignedProductByUserId?userId=${userId}`,
    
    GET_BUREAU_DECISION: (loanId) =>
        `${BASE_URL}/bureauDecisionNew?loanId=${loanId}`,
    
    GET_MATCHING_EMI_PLANS: (userId, loanId) =>
        `${BASE_URL}/matchingEmiPlans?userId=${userId}&loanId=${loanId}`,

    // Loan Transactions - using the correct type parameter
    GET_LOAN_TRANSACTIONS: (doctorId, params = {}) => {
        let url = `${BASE_URL}/getAllLoanDetailForDoctorNew?doctorId=${doctorId}&type=detail&loanStatus=${params.loanStatus || ''}&startDate=${params.startDate || ''}&endDate=${params.endDate || ''}&clinicName=${params.clinicName || ''}&applicationId=${params.applicationId || ''}&loanId=${params.loanId || ''}&mobileNumber=${params.mobileNumber || ''}`;
        
        if (params.parentDoctorId) {
            url += `&parentDoctorId=${params.parentDoctorId}`;
        }
        
        return url;
    },

    // Child Clinics
    GET_ALL_CHILD_CLINICS: (doctorId) =>
        `${BASE_URL}/getAllChildClinic?doctorId=${doctorId}`,

    // Loan Statistics
    GET_LOAN_COUNT_AND_AMOUNT: (doctorId, clinicName = '') => {
        let url = `${BASE_URL}/getLoanCountAndAmountForDoctor?doctorId=${doctorId}`;
        if (clinicName) {
            url += `&clinicName=${clinicName}`;
        }
        return url;
    },

    // Loan Details
    GET_LOAN_DETAILS_BY_USER_ID: (userId) =>
        `${BASE_URL}/userDetails/getLoanDetailsByUserId?userId=${userId}`,
    
    // Transaction Details
    GET_TRANSACTION_DETAILS: (loanId, doctorId) =>
        `${BASE_URL}/getAllLoanDetailForDoctorNew?doctorId=${doctorId}&loanId=${loanId}&type=detail`,

    // Document Upload
    UPLOAD_DOCUMENTS: () =>
        `${BASE_URL}/uploadDocuments`,

    // Reports
    GET_DISBURSE_DETAIL_FOR_REPORT: (userId) =>
        `${BASE_URL}/getDisburseDetailForReport?userId=${userId}`,

    // Invoice Upload
    UPLOAD_INVOICE: () =>
        `${BASE_URL}/uploadInvoice`,

    // Treatment Invoice Data
    GET_TREATMENT_INVOICE_DATA: (loanId) =>
        `${BASE_URL}/getTreatmentInvoiceData?loanId=${loanId}`,

    // Interest Enabled Status
    GET_INTEREST_ENABLED_BY_DOCTOR_ID: (doctorId) =>
        `${BASE_URL}/getInterestEnabledByDoctorId?doctorId=${doctorId}`,

    // Disbursement Data
    GET_DISBURSE_DATA_BY_LOAN_ID: (loanId) =>
        `${BASE_URL}/api/do-details/disbursal-order/getUnifiedDisburseDataByLoanId?loanId=${loanId}`,

    GET_FINAL_LENDER_DECISION: (loanId) =>
        `${BASE_URL}/getFinalLenderDecisionDetails?loanId=${loanId}`,

    OCR_TREATMENT_INVOICE: () =>
        'https://oculon.carepay.money/api/v1/treatment-invoice/',

    VERIFY_TREATMENT_INVOICE: (loanId) =>
        `https://oculon.carepay.money/api/v1/treatment-invoice/verify?loan_id=${loanId}`,

    UPDATE_TREATMENT_INVOICE_DATA: () =>
        `${BASE_URL}/updateTreatmentInvoiceData`,

    UPDATE_DO_TIMESTAMP: () =>
        `${BASE_URL}/api/do-details/disbursal-order/updateDoTimestamp`,

    // Scans — called directly from browser
    GET_SCANS: (params = {}) => {
        const query = new URLSearchParams();
        if (params.clinic) query.append('clinic', params.clinic);
        if (params.status) query.append('status', params.status);
        if (params.scan_type) query.append('scan_type', params.scan_type);
        const queryString = query.toString();
        return `${LUMI_API_BASE}/api/scans/${queryString ? `?${queryString}` : ''}`;
    },

    // Credit Ledger — called directly from browser (clinic = doctor_code)
    GET_CREDIT_LEDGER: (params = {}) => {
        const query = new URLSearchParams();
        if (params.clinic) query.append('clinic', params.clinic);
        const queryString = query.toString();
        if (params.id) {
            return `${LUMI_API_BASE}/api/credit-ledger/${params.id}/${queryString ? `?${queryString}` : ''}`;
        }
        return `${LUMI_API_BASE}/api/credit-ledger/${queryString ? `?${queryString}` : ''}`;
    },

    // Merchant payment links (credit top-up) — CarePay backend
    CREATE_MERCHANT_PAYMENT_LINK: () =>
        `${BASE_URL}/payments/merchant/links`,

    GET_MERCHANT_PAYMENT_LINK_DETAIL: (paymentLinkId) =>
        `${BASE_URL}/payments/merchant/links/detail?paymentLinkId=${encodeURIComponent(paymentLinkId)}`,

    LIST_MERCHANT_PAYMENT_LINKS: (merchantId) =>
        `${BASE_URL}/payments/merchant/links?merchantId=${encodeURIComponent(merchantId)}`,

    SYNC_MERCHANT_PAYMENT_LINK_STATUS: (paymentLinkId) =>
        `${BASE_URL}/payments/merchant/links/status?paymentLinkId=${encodeURIComponent(paymentLinkId)}`,
}
